<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Despesas"
    [operationDate]="this.model.operationDate"
    [id]="this.model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Tipo de Liquidação</div>
    <div class="card-body">
      <div class="col-12">
        <div>
          <div
            class="form-check form-check-inline"
            *ngFor="let item of ListSettlementTypes; index as i"
          >
            <input
              class="form-check-input"
              data-cy="settlementTypeId"
              type="radio"
              name="settlementTypeId"
              id="{{ 'tm-' + i + '-id' }}"
              [value]="item.id"
              [(ngModel)]="model.settlementTypeId"
            />
            <label class="form-check-label" for="{{ 'tm-' + i + '-id' }}">
              {{ item.name }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.Expenses"
    [settlementType]="model.settlementTypeId"
  >
  </app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-4" [class.has-error]="hasError('operationValue')">
          <label>Valor</label>
          <input
            type="text"
            class="form-control"
            data-cy="operationValue"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            required
            currencyMask
          />
        </div>
        <div
          class="col-4"
          *ngIf="expensesType"
          [class.has-error]="hasError('expenseTypeId')"
        >
          <label>Tipo de Despesas</label>
          <expense-type
            #expenseTypeComponent
            name="expenseType"
            [expenses]="expensesType"
            [(selectedExpenseId)]="model.expenseTypeId"
            required
            [readOnly]="!canEdit()"
          ></expense-type>
        </div>

        <div
          class="col-4"
          [class.has-error]="
            (settlementDate.invalid &&
              (settlementDate.dirty || settlementDate.touched)) ||
            hasError('settlementDate')
          "
        >
          <label>Data de Liquidação</label>
          <input
            [placeholder]="model.settlementDate"
            type="text"
            data-cy="settlementDate"
            class="form-control"
            name="settlementDate"
            #settlementDate
            [(ngModel)]="model.settlementDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <label>Detalhes</label>
          <textarea
            class="form-control"
            data-cy="details"
            rows="5"
            maxlength="1000"
            name="details"
            [(ngModel)]="model.details"
            [class.required-active]="
              thisForm.touched && this.model.details == null
            "
            required
          >
          </textarea>
          <span class="text-right" *ngIf="model.details != null"
            >{{ model.details.length }}/1000 caracteres</span
          ><br />
        </div>
      </div>
    </div>
  </div>

  <app-favored
    #favored
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [model]="model"
  ></app-favored>

  <br />
  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>
  <app-attachment
    #attachment
    [ticketId]="model.id"
    [canEdit]="canEdit()"
    [canChangeStatus]="canChangeStatus()"
    [statusDescription]="model.statusDescription"
    (tempTicketId)="setTempId($event)"
  ></app-attachment>

  <mat-expansion-panel *ngIf="showTransferStatus()" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title> Dados da Transferência </mat-panel-title>
      <mat-panel-description> (Clique para expandir...) </mat-panel-description>
    </mat-expansion-panel-header>
    <div style="padding: 1rem">
      <app-transfer-status
        #transferstatus
        [ticketId]="model.id"
      ></app-transfer-status>
    </div>
  </mat-expansion-panel>

  <br />
  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      data-cy="submit"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      data-cy="forward"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      data-cy="approve"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
      [disabled]="disableActionButtons()"
    />
    <input
      type="button"
      value="Reprovar"
      data-cy="reject"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
      [disabled]="disableActionButtons()"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      data-cy="duplicate"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
</form>
<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
